export interface CustomField {
    id: number;
    label: string;
    description: string;
    type: string;
    required: boolean;
    length: number;
}

export enum CustomFieldType {
    TEXT = 'text',
    NUMBER = 'number',
    PHOTO = 'photo'
}

export interface TurnstileWidgetProps {
    action?: string;
    widgetId?: string;
    size?: 'normal' | 'compact' | 'flexible';
    appearance?: 'execute' | 'always' | 'interaction-only';
    className?: string;
}

//create turnstile interface
export interface Turnstile {
    render: (container: string | HTMLElement, options?: {
        sitekey: string;
        theme?: 'light' | 'dark' | 'auto';
        callback?: (token: string) => void;
        'expired-callback'?: () => void;
        'error-callback'?: () => void;
        language?: string;
        action?: string;
        cData?: string;
        size?: 'normal' | 'compact';
    }) => string;
    reset: (widgetId: string) => void;
    getResponse: (widgetId: string) => string | undefined;
    remove: (widgetId: string) => void;
}